/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import {
    Button,
    Stack,
    Paper,
    Typography,
    Divider,
    Grid,
    Box,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';
import get from "lodash/get";
import map from "lodash/map";
import isEmpty from "lodash/isEmpty";

import Layout from "../../../../components/layout/Layout";
import Switch from "../../../../components/form/Switch";
import InputText from "../../../../components/form/InputText";
import Notification from "../../../../components/form/Notification";
import Alert from "../../../../components/form/Alert";
import Autocomplete from "../../../../components/form/AutoComplete";
import NumericFormatPhone from '../../../../components/form/FormatPhone';
import validator from "./validator";
import SaveIcon from '@mui/icons-material/Save';

import { postProvider} from "../../../../store/masters/thunk/provider/post"

const NewEdit = () => {
    const formikRef = useRef();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [__] = useTranslation("supplierMaster");
    const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });

    const post = useSelector(state => state.masters.provider.post);
    const provider = useSelector((state) => state.masters.provider);

    const odooCode = useSelector(state => state.masters.provider.codesOdoo);
    const logPeriodity = __(`logPeriodity`, { returnObjects: true });

   const user = useSelector(state => state.auth.login.dataUser);

    //Datos del LocalStorage
    const userData = JSON.parse(localStorage.getItem('userData'));

    const municipalities = map(userData?.municipalities, ({ municipalityId, municipalityName }) => ({
        value: municipalityId,
        label: municipalityName,
    }))

    const optionsCodeOdoo = map(odooCode?.data?.result,({ id, name }) => ({
        value: id,
        label: `${id} - ${name}`
    }))

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    const setError = (err, action) => {
        if (!isEmpty(err) && !!get(err, "Message", "")) {
            setAlert({
                open: true,
                title: get(err, "Message", ""),
                subtitle: (<ul>{map(get(err, "ValidationError", []), (item) => <li>{`• ${item}`}</li>)}</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        } else {
            setAlert({
                open: true,
                isDefault: true,
                btn: __(`${module}.actions.close`),
                func: closeAlert
            })
        }
    }

    useEffect(() => {
        if (get(post, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "post" }); navigate(`/masters/providers/${get(post, "id")}`); }
        if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post") }
    }, [post])


    const onSubmit = (values) => {

        const body = {
            comercialName: get(values, "commercialName", ""),
            legalName: get(values, "companyName", ""),
            muniId: get(values, "district", ""),
            address: get(values, "address", ""),
            phone: get(values, "phone", ""),
            email: get(values, "email", ""),
            corteId: get(values, "logPeriodicity", ""),
            providerOdooId: get(values, "odooCode", ""),
            isActive: get(values, "isActive", ""),
        }
       
        dispatch(postProvider(body))
    }

    const initialValues = {
        isActive: true,
        commercialName: "", 
        companyName: "",
        legalName: "", 
        district: "", 
        address: "",
        phone: "", 
        email: "", 
        logPeriodicity: "", 
        odooCode: "",
    }

    return (
        <Layout
            propsToolbar={{
                title: __(`head.new.name`),
                srute: __(`head.new.code`)
            }}
        >
            <Formik innerRef={formikRef} initialValues={initialValues} validationSchema={validator(__)} onSubmit={onSubmit}>
                {formik => (
                    <form id="form-client" onSubmit={get(formik, "handleSubmit")}>
                        <Paper className='p-4'>
                            <Stack direction="row" spacing={2} justifyContent="flex-end">
                                <LoadingButton variant="contained" color="secondary" startIcon={<SaveIcon/>} type="submit" loading={get(post, "isLoading")}>{__(`action.save`)}</LoadingButton>
                                <Button variant='outlined' color="secondary" onClick={() => navigate("/masters/providers/")} disabled={get(post, "isLoading")} >{__(`action.cancel`)}</Button>
                            </Stack>
                        </Paper>
                        <Paper className='mt-4'>
                            <Stack className='p-4' direction="row" spacing={2} justifyContent="space-between">
                                <Typography component="h4" variant="h4">{__(`labels.1`)}</Typography>
                                <Switch formik={formik} name="isActive" __={__} />
                            </Stack>
                            <Divider />
                            <Box className='p-4' >
                                <Grid container spacing={{ xs: 2, md: 3 }}>
                                <Grid item xs={12} sm={6} >
                                        <InputText
                                            formik={formik}
                                            name="commercialName"
                                            label={__(`form.commercialName.label`)}
                                            placeholder={__(`form.commercialName.placeholder`)}
                                            disabled={get(post, "isLoading", false)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                        <InputText
                                            formik={formik}
                                            name="companyName"
                                            label={__(`form.companyName.label`)}
                                            placeholder={__(`form.companyName.placeholder`)}
                                            disabled={get(post, "isLoading", false)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <InputText
                                            formik={formik}
                                            name="email"
                                            label={__(`form.email.label`)}
                                            placeholder={__(`form.email.placeholder`)}
                                            disabled={get(post, "isLoading", false)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <InputText
                                            formik={formik}
                                            name="phone"
                                            label={__(`form.phone.label`)}
                                            placeholder={__(`form.phone.placeholder`)}
                                            disabled={get(post, "isLoading", false)}
                                            InputProps={{
                                                inputComponent: NumericFormatPhone,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography className='pt-4' component="p" variant="bmr" color="text.lite" >{__(`labels.2`)}</Typography>
                                    </Grid>
                                   {/*} <Grid item xs={12} sm={6} md={12}> Para que se vea en toda la pantalla*/} 
                                   <Grid item xs={12} sm={6}>
                                        <InputText
                                            formik={formik}
                                            name="address"
                                            label={__(`form.address.label`)}
                                            placeholder={__(`form.address.placeholder`)}
                                            disabled={get(post, "isLoading", false)}
                                            multiline
                                            rows={4}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                         <Autocomplete
                                            formik={formik}
                                            name="district"
                                            label={__(`form.district.label`)}
                                            placeholder={__(`form.district.placeholder`)}
                                            options={municipalities}
                                            loading={get(provider, "isLoading")}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography className='pt-4' component="p" variant="bmr" color="text.lite" >{__(`labels.3`)}</Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6} >
                                        <Autocomplete
                                            formik={formik}
                                            name="odooCode"
                                            label={__(`form.odooCode.label`)}
                                            placeholder={__(`form.odooCode.placeholder`)}
                                            disabled={get(post, "isLoading", false)}
                                            options={optionsCodeOdoo}
                                        />
                                    </Grid> 
                                    <Grid item xs={12} sm={6} >
                                        <Autocomplete
                                            formik={formik}
                                            name="logPeriodicity"
                                            label={__(`form.logPeriodicity.label`)}
                                            placeholder={__(`form.logPeriodicity.placeholder`)}
                                            disabled={get(post, "isLoading", false)}
                                            options={logPeriodity}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        </Paper>
                    </form>
                )}
            </Formik>
            <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
            <Alert
                __={__}
                title={get(alert, "title")}
                subtitle={get(alert, "subtitle")}
                btn1={{ func: get(alert, "func") }}
                btn2={{}}
                type={get(alert, "type")}
                openAlert={get(alert, "open")}
                closeAlert={closeAlert}
            />
        </Layout>
    )
}

export default NewEdit
